import { useQuery } from "@tanstack/react-query";
import { GfFlyerItemDto } from "@swagger/typescript-fetch-goflyer";
import { adminApiServiceRaw } from "../../../utils/api";
import { reviewKeys } from "./queryKeys";

export const useFlyerItemInspector = (
  flyerItemId: string | undefined,
  reqOptions: { headers: { Authorization: string } },
) => {
  const authToken = reqOptions.headers.Authorization;

  const query = useQuery({
    queryKey: reviewKeys.itemInspector(flyerItemId ?? ""),
    queryFn: ({ signal }) =>
      adminApiServiceRaw.getOneBaseGfFlyerItemAdminControllerGfFlyerItem(
        flyerItemId as string,
        undefined,
        undefined,
        undefined,
        { headers: { Authorization: authToken }, signal },
      ),
    enabled: !!flyerItemId,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  });

  return {
    item: flyerItemId ? (query.data as GfFlyerItemDto | undefined) : undefined,
    // Only skeleton on first load for this item — not on background refetch.
    loading: !!flyerItemId && query.isLoading,
  };
};
